import React from 'react';
import { BoxIcon } from 'lucide-react';
interface StatusCardProps {
  title: string;
  icon: BoxIcon;
  children: React.ReactNode;
  accentColor?: 'blue' | 'green' | 'orange' | 'slate';
  className?: string;
}
export function StatusCard({
  title,
  icon: Icon,
  children,
  accentColor = 'slate',
  className = ''
}: StatusCardProps) {
  const colorStyles = {
    blue: 'bg-blue-50 text-blue-700 border-blue-100',
    green: 'bg-emerald-50 text-emerald-700 border-emerald-100',
    orange: 'bg-orange-50 text-orange-700 border-orange-100',
    slate: 'bg-slate-50 text-slate-700 border-slate-100'
  };
  return <div className={`bg-white rounded-xl border border-slate-200 shadow-sm p-6 flex flex-col h-full ${className}`} data-id="element-416">
      <div className="flex items-center gap-3 mb-4" data-id="element-417">
        <div className={`p-2 rounded-lg ${colorStyles[accentColor]}`} data-id="element-418">
          <Icon size={20} data-id="element-419" />
        </div>
        <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wider" data-id="element-420">
          {title}
        </h3>
      </div>
      <div className="flex-1" data-id="element-421">{children}</div>
    </div>;
}